import { TOPCON_BORDER_RADIUS, TOPCON_BOX_SHADOW, TOPCON_COLORS, TOPCON_FONTS, TOPCON_LAYOUT, TOPCON_SPACING, } from './topconThemeConf';
import { createTheme } from '@material-ui/core/styles';
import { border, toCssValue } from '../themeUtils';
const topconThemeConf = {
    color: {
        primary: {
            lightest: TOPCON_COLORS.primary.lightest,
            light: TOPCON_COLORS.primary.light,
            main: TOPCON_COLORS.primary.main,
            dark: TOPCON_COLORS.primary.dark,
            darkest: TOPCON_COLORS.primary.darkest,
        },
        brand: {
            lightest: TOPCON_COLORS.brand.lightest,
            light: TOPCON_COLORS.brand.light,
            main: TOPCON_COLORS.brand.main,
            dark: TOPCON_COLORS.brand.dark,
            darkest: TOPCON_COLORS.brand.darkest,
        },
        success: {
            light: TOPCON_COLORS.success.light,
            main: TOPCON_COLORS.success.main,
            dark: TOPCON_COLORS.success.dark,
        },
        error: {
            lightest: TOPCON_COLORS.error.lightest,
            light: TOPCON_COLORS.error.light,
            main: TOPCON_COLORS.error.main,
            dark: TOPCON_COLORS.error.dark,
        },
        warning: {
            lightest: TOPCON_COLORS.warning.lightest,
            light: TOPCON_COLORS.warning.light,
            main: TOPCON_COLORS.warning.main,
        },
        grey: {
            lightest: TOPCON_COLORS.grey.lightest,
            light: TOPCON_COLORS.grey.light,
            default: TOPCON_COLORS.grey.default,
            dark: TOPCON_COLORS.grey.dark,
            darkest: TOPCON_COLORS.grey.darkest,
        },
        input: {
            placeholder: TOPCON_COLORS.grey.default,
            border: TOPCON_COLORS.grey.default,
        },
        background: {
            body: TOPCON_COLORS.background.body,
            light: TOPCON_COLORS.background.light,
            dark: TOPCON_COLORS.background.dark,
        },
        font: {
            dark: TOPCON_COLORS.font.dark,
            light: TOPCON_COLORS.font.light,
        },
        common: {
            contentHover: TOPCON_COLORS.common.contentHover,
        },
    },
    font: {
        family: TOPCON_FONTS.family,
        size: {
            small: TOPCON_FONTS.size.small,
            mediumSmall: TOPCON_FONTS.size.mediumSmall,
            medium: TOPCON_FONTS.size.medium,
            mediumBig: TOPCON_FONTS.size.mediumBig,
            big: TOPCON_FONTS.size.big,
            caption: TOPCON_FONTS.size.caption,
            title: TOPCON_FONTS.size.title,
            heading: TOPCON_FONTS.size.heading,
        },
        lineHeight: {
            small: TOPCON_FONTS.lineHeight.small,
            mediumSmall: TOPCON_FONTS.lineHeight.mediumSmall,
            medium: TOPCON_FONTS.lineHeight.medium,
            mediumBig: TOPCON_FONTS.lineHeight.mediumBig,
            big: TOPCON_FONTS.lineHeight.big,
        },
        weight: {
            light: TOPCON_FONTS.weight.light,
            normal: TOPCON_FONTS.weight.normal,
            bold: TOPCON_FONTS.weight.bold,
        },
    },
    common: {
        borderRadius: {
            low: TOPCON_BORDER_RADIUS.low,
            default: TOPCON_BORDER_RADIUS.default,
            high: TOPCON_BORDER_RADIUS.high,
            onlyTop: TOPCON_BORDER_RADIUS.onlyTop,
            onlyRight: TOPCON_BORDER_RADIUS.onlyRight,
        },
        shadow: {
            light: TOPCON_BOX_SHADOW.light,
            default: TOPCON_BOX_SHADOW.default,
            dark: TOPCON_BOX_SHADOW.dark,
        },
    },
    space: {
        layout: {
            fullWidth: TOPCON_SPACING.layout.fullWidth,
            partialWidth: TOPCON_SPACING.layout.partialWidth,
        },
        margin: {
            smallest: TOPCON_SPACING.margin.smallest,
            small: TOPCON_SPACING.margin.small,
            default: TOPCON_SPACING.margin.default,
            large: TOPCON_SPACING.margin.large,
            largest: TOPCON_SPACING.margin.largest,
            horizontalDefault: TOPCON_SPACING.margin.horizontalDefault,
            verticalDefault: TOPCON_SPACING.margin.verticalDefault,
        },
        padding: {
            smallest: TOPCON_SPACING.padding.smallest,
            small: TOPCON_SPACING.padding.small,
            default: TOPCON_SPACING.padding.default,
            large: TOPCON_SPACING.padding.large,
            largest: TOPCON_SPACING.padding.largest,
            horizontalDefault: TOPCON_SPACING.padding.horizontalDefault,
            verticalDefault: TOPCON_SPACING.padding.verticalDefault,
        },
    },
    layout: {
        width: {
            full: TOPCON_LAYOUT.width.full,
            partial: TOPCON_LAYOUT.width.partial,
        },
        sidebar: {
            full: TOPCON_LAYOUT.sidebar.full,
        },
        header: {
            topBar: TOPCON_LAYOUT.header.topBar,
            menu: TOPCON_LAYOUT.header.menu,
        },
    },
    components: {
        table: {
            header: {
                background: TOPCON_COLORS.brand.main,
                color: TOPCON_COLORS.font.light,
            },
            headerSecondary: {
                background: TOPCON_COLORS.brand.main,
                color: TOPCON_COLORS.font.light,
            },
            th: {
                background: TOPCON_COLORS.background.light,
                color: TOPCON_COLORS.font.dark,
            },
            row: {
                hover: TOPCON_COLORS.common.contentHover,
            },
        },
        link: {
            colors: {
                normal: TOPCON_COLORS.brand.main,
                hover: TOPCON_COLORS.brand.light,
            },
        },
        header: {
            colors: {
                background: TOPCON_COLORS.brand.main,
                text: TOPCON_COLORS.font.light,
                menuIcon: TOPCON_COLORS.font.light,
            },
        },
        menu: {
            colors: {
                background: TOPCON_COLORS.background.light,
                text: TOPCON_COLORS.font.dark,
                selected: TOPCON_COLORS.brand.main,
            },
        },
        userMenu: {
            colors: {
                headerBackground: TOPCON_COLORS.primary.light,
                headerText: TOPCON_COLORS.font.dark,
                buttonBackground: TOPCON_COLORS.background.light,
                buttonText: TOPCON_COLORS.font.dark,
                buttonBackgroundHover: TOPCON_COLORS.primary.main,
                triggerBackground: TOPCON_COLORS.background.light,
                triggerText: TOPCON_COLORS.brand.main,
                userIconBackground: TOPCON_COLORS.primary.darkest,
                userIconText: TOPCON_COLORS.font.light,
            },
        },
        tabs: {
            indicator: TOPCON_COLORS.background.light,
            background: TOPCON_COLORS.brand.main,
            color: TOPCON_COLORS.font.light,
        },
        listItem: {
            backgroundHover: TOPCON_COLORS.background.light,
            backgroundSelected: TOPCON_COLORS.primary.main,
            textHover: TOPCON_COLORS.font.dark,
            textSelected: TOPCON_COLORS.font.light,
        },
        sidebar: {
            colors: {
                itemSelected: TOPCON_COLORS.brand.main,
                border: TOPCON_COLORS.brand.main,
            },
        },
        passwordSuggestionBox: {
            container: {
                background: TOPCON_COLORS.background.light,
                text: TOPCON_COLORS.font.dark,
            },
            arrow: {
                background: TOPCON_COLORS.background.light,
            },
            rule: {
                iconSuccess: TOPCON_COLORS.success.main,
                iconError: TOPCON_COLORS.error.main,
                text: TOPCON_COLORS.font.dark,
            },
        },
        logoutButton: {
            background: TOPCON_COLORS.grey.lightest,
            backgroundHover: TOPCON_COLORS.grey.light,
            text: TOPCON_COLORS.font.dark,
        },
    },
};
export function createMyTheme(options) {
    return createTheme({
        palette: {
            primary: {
                light: TOPCON_COLORS.primary.light,
                main: TOPCON_COLORS.primary.main,
                dark: TOPCON_COLORS.primary.dark,
            },
            secondary: {
                light: TOPCON_COLORS.brand.light,
                main: TOPCON_COLORS.brand.main,
                dark: TOPCON_COLORS.brand.dark,
            },
            text: {
                primary: TOPCON_COLORS.font.dark,
                secondary: TOPCON_COLORS.font.light,
            },
        },
        typography: {
            fontFamily: TOPCON_FONTS.family,
            h5: {
                fontSize: '1.25rem',
                lineHeight: '1.5',
            },
            subtitle1: {
                lineHeight: '1.25',
            },
            body1: {
                color: '#4a4a4a',
            },
            caption: {
                color: '#333',
                fontSize: '0.625rem',
            },
            h4: {
                fontSize: '1.5rem',
                fontWeight: 500,
                color: 'black',
            },
        },
        overrides: {
            MuiAutocomplete: {
                noOptions: {
                    color: TOPCON_COLORS.font.dark,
                    fontSize: TOPCON_FONTS.size.medium,
                },
            },
            MuiInput: {
                underline: {
                    '&:after, &:before': {
                        borderBottom: border('currentColor'),
                    },
                    '&:hover:not($disabled):not($focused):not($error):before': {
                        borderBottomColor: 'currentColor',
                    },
                },
            },
            MuiFormHelperText: {
                root: {
                    marginTop: 2,
                    fontSize: '0.70rem',
                    lineHeight: '0.9em',
                },
            },
            MuiFormLabel: {
                root: {
                    color: TOPCON_COLORS.grey.light,
                    '&$disabled': {
                        color: TOPCON_COLORS.font.dark,
                    },
                    '&$focused': {
                        color: TOPCON_COLORS.font.dark,
                    },
                },
            },
            MuiInputLabel: {
                formControl: {
                    color: TOPCON_COLORS.font.dark,
                },
            },
            MuiStepLabel: {
                root: {
                    textTransform: 'uppercase',
                },
                label: {
                    color: TOPCON_COLORS.font.dark,
                },
                completed: {
                    '&:hover': {
                        cursor: 'pointer',
                        textDecoration: 'underline',
                    },
                },
                active: {
                    fontWeight: `${TOPCON_FONTS.weight.bold} !important`,
                },
                '&$disabled': {
                    color: TOPCON_COLORS.grey.light,
                },
            },
            MuiStepIcon: {
                root: {
                    '& text': {
                        fill: TOPCON_COLORS.font.light,
                        fontSize: TOPCON_FONTS.size.mediumSmall,
                        fontWeight: TOPCON_FONTS.weight.bold,
                    },
                },
                completed: {
                    color: `${TOPCON_COLORS.primary.main} !important`,
                },
                active: {
                    color: `${TOPCON_COLORS.primary.main} !important`,
                },
            },
            MuiInputBase: {
                input: {
                    padding: toCssValue([7, 0, 2]),
                    fontSize: TOPCON_FONTS.size.mediumBig,
                },
            },
            MuiRadio: {
                root: {
                    color: TOPCON_COLORS.font.dark,
                },
            },
            MuiSelect: {
                select: {
                    padding: toCssValue([7, 0, 6]),
                },
            },
        },
        ...options,
    });
}
export const topconTheme = createMyTheme(topconThemeConf);
//# sourceMappingURL=topconTheme.js.map